import axios from "axios";
import cardList from "./builder/card-list.js";
import searchFilters from "./builder/search-filters.js";
import searchResults from "./builder/search-results.js";
import BUILDER_MOBILE_TABS from "../../mappings/BuilderMobileTabs.js";
import SORTING_OPTIONS from "../../mappings/SortingOptions.js";
import { getSessionStorage, setSessionStorage } from "../../utils/storage.js";
import {mapGetters} from "vuex";

const state = {
    activeMobileTab: 'decklist',
    error: '',
    isLoading: false,
    isInStockOnly: false,
    sortingOption: getSessionStorage('deckbuilderSelectedSorting') || Object.keys(SORTING_OPTIONS)[0],
    listedCards: [],
    notFoundCards: [],
    userConditions: [],
    totalFetchedCards: 0,
    errorMessage: ""
};

const splitDecklist = (decklist, splitMaxNumber = 2) => {
    const individualCards = decklist.split(/\r?\n/);

    const groupCardsInLists = individualCards.reduce((accumulator, currentValue) => {
        if (accumulator.length && accumulator[accumulator.length - 1].length < splitMaxNumber) {
            accumulator[accumulator.length - 1] = [...accumulator[accumulator.length - 1], currentValue];
        } else {
            accumulator[accumulator.length || 0] = [currentValue];
        }
        return accumulator;
    }, []);

    const listFormatArray = groupCardsInLists.reduce((accumulator, currentArray) => {
        return [...accumulator, currentArray.join("\r\n")]
    }, []);

    return listFormatArray;
}

export default {
    namespaced: true,
    modules: {
        cardList,
        searchFilters,
        searchResults,
    },
    state,
    getters: {
        getPartnerId: () => {
          return CK_PARTNER || '';
        },
        getEcomCartList: (state,getters) => {


            let ecomCartList = _.flatMap(getters['cardList/getList'],(itemList) => {

                return _.flatMap(itemList, (itemsByStyle) => {
                    let completeItems = [];
                    _.forEach(itemsByStyle, (item) => {
                        if(parseInt(item.total_requested) > 0) {
                            const { name, model } = getters['searchResults/getCardInfoById'](item.product_id);

                            completeItems.push({
                                item_id: item.product_id,
                                item_name: name,
                                affiliation: getters['getPartnerId'],
                                item_category: model,
                                item_variant: item.style,
                                price: item.price,
                                quantity: item.total_requested,
                            });
                        }

                    });
                    return completeItems;
                });

            });

            return  ecomCartList;

        },
        getSortingOption: (state) => state.sortingOption,
        getIsLoading: (state) => state.isLoading,
        getIsInStockOnly: (state) => state.isInStockOnly,
        getActiveMobileTab: (state) => state.activeMobileTab,
        getListedCards: (state) => state.listedCards,
        getSortResultsByDeckOrder: (state) => state.listedCards,
        getSortResultsByNameAZ: (state) => {
            const listedCards = [...state.listedCards];
            return listedCards.sort((a, b) => {
                return a.title < b.title ? -1 :
                    a.title > b.title ? 1 :
                        0;
            })
        },
        getSortResultsByNameZA: (state) => {
            const listedCards = [...state.listedCards];
            return listedCards.sort((a, b) => {
                return a.title < b.title ? 1 :
                    a.title > b.title ? -1 :
                        0;
            });
        },
        getSortResultsByCardType: (state, getters) => {
            const listedCards = [...state.listedCards];
            return listedCards.sort((a, b) => {
                const cardAType = getters['searchResults/getCardInfoBySlug'](a.slug)[0].type;
                const cardBType = getters['searchResults/getCardInfoBySlug'](b.slug)[0].type;
                return cardAType < cardBType ? -1 :
                    cardAType > cardBType ? 1 :
                        0;
            });
        },
        getSortResultsByPrice: (state, getters) => {
            const listedCards = [...state.listedCards];
            return listedCards.sort((a, b) => {
                const cardAPrice = getters['cardList/getTotalPriceBySlug'](a.slug);
                const cardBPrice = getters['cardList/getTotalPriceBySlug'](b.slug);
                return cardAPrice < cardBPrice ? -1 :
                    cardAPrice > cardBPrice ? 1 :
                        0;
            });
        },
        getSortResultsByEmptyFirst: (state, getters) => {
            const listedCards = [...state.listedCards];
            return listedCards.sort((a) => {
                const cardAPrice = getters['cardList/getTotalSelectedBySlug'](a.slug);
                return cardAPrice == 0 ? -1 : 0;
            });
        },
        getSortedListedCards: (state, getters) => {
            if (getters.getSortingOption === 'deckOrder')
                return getters.getSortResultsByDeckOrder;
            if (getters.getSortingOption === 'nameAZ')
                return getters.getSortResultsByNameAZ;
            if (getters.getSortingOption === 'nameZA')
                return getters.getSortResultsByNameZA;
            if (getters.getSortingOption === 'cardType')
                return getters.getSortResultsByCardType;
            if (getters.getSortingOption === 'price')
                return getters.getSortResultsByPrice;
            if (getters.getSortingOption === 'empty')
                return getters.getSortResultsByEmptyFirst;
            return getters.getListedCards;
        },
        getNotFoundCardList: (state) => state.notFoundCards,
        getTotalFetchedCards: (state) => state.totalFetchedCards,
        getUserConditions: (state) => state.userConditions,
        getErrorMessage: (state) => state.errorMessage,
    },
    actions: {
        updateActiveMobileTab: ({ commit }, payload) => {
            if (BUILDER_MOBILE_TABS[payload]) {
                commit('updateActiveMobileTab', payload);
            }
        },
        updateBuilderCardList: async ({ dispatch, getters }) => {

            dispatch('updateActiveMobileTab', 'results');
            dispatch('updateIsLoading', true);
            dispatch('updateTotalFetchedCards', 0);

            const splitDeckList = splitDecklist(getters['searchFilters/getDecklist'], 25);

            const promisesArray = splitDeckList.map(list => {
                return axios.post('/api/builder', {
                    submit: 1,
                    cardData: list, // string
                    autofill_lp: getters['searchFilters/getAutofillPrice'] ? '1' : undefined, // false or '1'
                    autofill_group_edition: getters['searchFilters/getAutofillEdition'] ? '1' : undefined, // false or '1'
                    autofill_group_foils: getters['searchFilters/getAutofillFoils'] ? '1' : undefined, // false or '1'
                    format: getters['searchFilters/getFormat'].length ?
                        getters['searchFilters/getFormat'] :
                        undefined,
                    in_stock: getters['searchFilters/getInStock'] ? '1' : undefined,
                    x_promo: getters['searchFilters/getExcludePromo'] ? '1' : undefined, // 'false' or '1'
                    x_abu: getters['searchFilters/getExcludeABU'] ? '1' : undefined, // 'false' or '1'
                    NM: getters['searchFilters/getConditionNM'] ? '1' : undefined, // 'false' or '1'
                    EX: getters['searchFilters/getConditionEX'] ? '1' : undefined, // 'false' or '1'
                    VG: getters['searchFilters/getConditionVG'] ? '1' : undefined, // 'false' or '1'
                    G: getters['searchFilters/getConditionG'] ? '1' : undefined, // 'false' or '1'
                }).then((({ data }) => {
                    if (!data.error)
                        dispatch('updateTotalFetchedCards', getters['getTotalFetchedCards'] + data.results?.length);
                        dispatch('updateNotFoundCardList', data.not_found)
                    return data;
                }));
            });

            Promise.all(promisesArray).then((callbacks) => {
                const {
                    error,
                    list,
                    notFound,
                    results,
                    userConditions,
                } = callbacks.reduce((accumulator = {}, currentValue) => {
                    return {
                        error: accumulator?.error || currentValue.error,
                        list: accumulator?.list ?
                            [...accumulator?.list, ...currentValue.list] :
                            currentValue.list,
                        notFound: currentValue?.notFound ?
                            [...accumulator?.notFound, ...currentValue.not_found] :
                            currentValue.not_found,
                        results: accumulator?.results ?
                            [...accumulator?.results, ...currentValue.results] :
                            currentValue.results,
                        userConditions: currentValue.user_conditions,
                    };
                }, {});

                dispatch('updateErrorMessage', error);

                dispatch('updateIsInStockOnly', getters['searchFilters/getInStock']);
                dispatch('updateIsLoading', false);
                dispatch('updateListedCards', list);
                dispatch('updateUserConditions', userConditions);
                dispatch('cardList/addPreselectedCardList', results);
                dispatch('searchResults/updateResults', results);

                if (notFound) {
                    dispatch('updateNotFoundCardList', notFound)
                }
            });
        },
        updateIsLoading: ({ commit }, value) => commit('updateIsLoading', value),
        updateIsInStockOnly: ({ commit }, value) => commit('updateIsInStockOnly', value),
        updateListedCards: ({ commit }, value) => commit('updateListedCards', value),
        updateNotFoundCardList: ({ commit }, value) => commit('updateNotFoundCardList', value),
        updateSortingOption: ({ commit }, value) => commit('updateSortingOption', value),
        updateTotalFetchedCards: ({ commit }, value) => commit('updateTotalFetchedCards', value),
        updateUserConditions: ({ commit }, value) => commit('updateUserConditions', value),
        updateErrorMessage: ({ commit }, value) => commit('updateErrorMessage', value),
    },
    mutations: {
        updateIsInStockOnly: (state, payload) =>
            state.isInStockOnly = payload,
        updateActiveMobileTab: (state, payload) =>
            state.activeMobileTab = payload,
        updateIsLoading: (state, payload) =>
            state.isLoading = payload,
        updateListedCards: (state, payload) =>
            state.listedCards = payload,
        updateNotFoundCardList: (state, payload) =>
            state.notFoundCards.push(...payload),
        updateSortingOption: (state, payload) => {
            state.sortingOption = payload;
            setSessionStorage('deckbuilderSelectedSorting', payload);
        },
        updateTotalFetchedCards:(state, payload) =>
            state.totalFetchedCards = payload,
        updateUserConditions: (state, payload) =>
            state.userConditions = Object.values(payload),
        updateErrorMessage: (state, payload) =>
            state.errorMessage = payload,
    }
}
